/* src/app/login/login.component.scss */
.p-inputtext {
  width: 100%;
}
:host ::ng-deep .p-button {
  width: 100%;
}
:host ::ng-deep .p-card-body {
  margin-top: 50%;
}
.title {
  text-align: center;
}
.login-error {
  color: red;
}
.logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 1em;
}
.logo-container .logo-svg {
  width: 150px;
}
.logo-container .fa-lock {
  margin-left: 0.5em;
  font-size: 28px;
}
/*# sourceMappingURL=login.component.css.map */
